import * as actions from './redux/actions';
import reducer from './redux/reducer';
import SiteHeader from './SiteHeader';
export { actions, reducer };
export default SiteHeader;

//# sourceMappingURL=index.js.map